import { Link } from 'react-router-dom';
import { reviewSeat, type LocalReview, type LocalState } from '@anjabom/core';

export function SeatMemoryList({ reviews, state }: { reviews: LocalReview[]; state: LocalState }) {
  return <div className="seat-memory-list">{reviews.map((review) => {
    const seat = reviewSeat(review, state);
    return <article className="seat-memory" key={review.id}>
      <p className="micro">{review.observedAt} · 이 기기에만 남긴 경험</p>
      <h3>{seat ? `${seat.sectionCode} ${seat.rowLabel}열 ${seat.seatNumber}번` : '좌석 정보가 남아 있지 않은 기록이에요.'}</h3>
      {seat ? <p className="micro">{seat.venueName} · {seat.spaceName}{seat.instanceLabel ? ` · ${seat.instanceLabel}` : ''}</p> : null}
      {review.note ? <p className="memory-note">{review.note}</p> : null}
      <div className="memory-observations">{Object.entries(review.scores).filter(([, value]) => value !== null).map(([name, value]) => <span key={name}>{name} · {value === 0 ? '불편 없음' : value === 1 ? '조금 느낌' : value === 2 ? '불편했음' : '많이 불편했음'}</span>)}</div>
      {review.actualPaid !== null ? <p className="micro">이때 실제 낸 돈 {review.actualPaid.toLocaleString('ko-KR')}원</p> : null}
      {seat ? <Link className="button button-secondary" to={`/seat/${seat.candidateId}`}>이 자리 다시 확인하기</Link> : <p className="micro">기억의 내용은 보존했어요. 좌표를 추측해서 연결하지 않아요.</p>}
    </article>;
  })}</div>;
}
